import type { FaireProductEntity } from "../../entity_types/product";

export const p_ryp3c58q92: FaireProductEntity = {
  token: "p_ryp3c58q92",
  type: "product",
  name: "Matcha Whisk",
  brandToken: "b_4fvfm8f5",
  brandName: "DONA",
  imageUrl:
    "https://cdn.faire.com/fastly/b36de1d694e24126ffd9ef117f9d3d76086f66a2c5dd6dd3ef786d6af7f43bb9.png",
  galleryImageUrls: [],
  priceDollars: 9,
  description: "A bamboo whisk for making the perfect matcha.",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-31T17:28:23.840Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
